import {AdjustmentCreateListElementType, AdjustmentCreateType} from "../interface";
import {invDetailInit} from "../../../inv/detail/state";
import moment from "moment";

export const adjustmentCreateInit: AdjustmentCreateType = {
    accountName: "",
    changeAt: moment().format("YYYY-MM-DD"),
    code: "",
    createEachAdjustmentReqList: [],
    memo: ""
}

export const adjustmentCreateListElementInit: AdjustmentCreateListElementType = {
    ...invDetailInit,
    changeAmount: 0,
    inventoryId: 0
}